import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "../../../helpers";
// Icons
import selectRightIcon from "../../../components/Icons/selectRightIcon.svg";
import microsoftLogo from "../../../components/Icons/microsoftLogo.svg";
import wadeIcon from "../../../components/Icons/wadeIcon.svg";
import emailLogo from "../../../components/Icons/emailLogo.svg";

const Authenticator = () => {
  const [selectAuthenticator, setSelectAuthenticator] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleauthenticator = (authType: string) => {
    setSelectAuthenticator(authType);
  };

  const nextButtonClickHandler = () => {
    if (selectAuthenticator === "email") {
      navigate("/emailVerification", {
        state: {
          email: location.state.email,
          password: location.state.password,
          user_id: location.state.user_id,
        },
      });
    } else if (selectAuthenticator === "microsoft") {
      navigate("/microsoftVerification", {
        state: {
          email: location.state.email,
          password: location.state.password,
          user_id: location.state.user_id,
        },
      });
    }
  };

  // Common card styles
  const getCardClasses = (isSelected: boolean) =>
    cn(
      "tw-relative tw-flex tw-items-center tw-p-4 tw-border-2 tw-rounded-xl tw-cursor-pointer tw-transition-all tw-duration-200",
      isSelected
        ? "tw-border-[#03234a] tw-bg-[#03234a]/5 tw-shadow-md"
        : "tw-border-gray-200 tw-bg-white hover:tw-border-gray-300 hover:tw-shadow-sm"
    );

  return (
    <div className="tw-min-h-screen tw-bg-gray-100 tw-flex tw-justify-center tw-items-center tw-p-4">
      <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden tw-flex tw-flex-col tw-relative tw-w-full tw-max-w-2xl">
        {/* Top Accent Line */}
        <div className="tw-h-2 tw-bg-gradient-to-r tw-from-[#03234a] tw-to-[#04346c] tw-w-full"></div>

        <div className="tw-p-6 md:tw-p-10">
          {/* Header Section */}
          <div className="tw-flex tw-flex-col tw-items-center tw-mb-8">
            <div className="tw-mb-6 tw-bg-gray-50 tw-p-4 tw-rounded-full tw-shadow-sm">
              <img src={wadeIcon} alt="WADE Logo" className="tw-h-8" />
            </div>
            <h2 className="tw-text-[#03234a] tw-text-2xl md:tw-text-3xl tw-font-bold tw-text-center tw-mb-2">
              Secure Your Account
            </h2>
            <p className="tw-text-gray-500 tw-text-center tw-text-sm md:tw-text-base">
              Choose a multi-factor authentication method below
            </p>
          </div>

          {/* Options Grid */}
          <div className="tw-flex tw-flex-col tw-gap-4 tw-mb-8">
            {/* Microsoft Authenticator Option */}
            <div
              onClick={() => handleauthenticator("microsoft")}
              className={getCardClasses(selectAuthenticator === "microsoft")}
            >
              <div
                className={cn(
                  "tw-flex-shrink-0 tw-w-12 tw-h-12 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-white tw-border tw-border-gray-200 tw-mr-4",
                  selectAuthenticator === "microsoft" && "tw-border-blue-200"
                )}
              >
                <img src={microsoftLogo} className="tw-w-6 tw-h-6" alt="Microsoft" />
              </div>
              <div className="tw-flex-1">
                <h6 className="tw-text-[#03234a] tw-font-bold tw-text-lg tw-mb-1">
                  Microsoft Authenticator
                </h6>
                <p className="tw-text-gray-500 tw-text-sm tw-leading-tight">
                  Use the Microsoft Authenticator app for secure verification
                </p>
              </div>
              {selectAuthenticator === "microsoft" && (
                <div className="tw-absolute tw-top-4 tw-right-4 md:tw-static md:tw-ml-4 tw-text-[#03234a]">
                  <img src={selectRightIcon} className="tw-w-6 tw-h-6" alt="Selected" />
                </div>
              )}
            </div>

            {/* Email Authentication Option */}
            <div
              onClick={() => handleauthenticator("email")}
              className={getCardClasses(selectAuthenticator === "email")}
            >
              <div
                className={cn(
                  "tw-flex-shrink-0 tw-w-12 tw-h-12 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-white tw-border tw-border-gray-200 tw-mr-4",
                  selectAuthenticator === "email" && "tw-border-blue-200"
                )}
              >
                <img src={emailLogo} className="tw-w-7 tw-h-auto" alt="Email" />
              </div>
              <div className="tw-flex-1">
                <h6 className="tw-text-[#03234a] tw-font-bold tw-text-lg tw-mb-1">
                  Email Authentication
                </h6>
                <p className="tw-text-gray-500 tw-text-sm tw-leading-tight">
                  Receive a 6-digit verification code to your email address
                </p>
              </div>
              {selectAuthenticator === "email" && (
                <div className="tw-absolute tw-top-4 tw-right-4 md:tw-static md:tw-ml-4 tw-text-[#03234a]">
                  <img src={selectRightIcon} className="tw-w-6 tw-h-6" alt="Selected" />
                </div>
              )}
            </div>
          </div>

          {/* Action Button */}
          <Button
            className="tw-w-full tw-h-12 tw-bg-[#03234a] tw-text-white tw-font-bold tw-tracking-wide tw-rounded-xl hover:tw-bg-[#052d5e] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-[#03234a] disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-all tw-shadow-lg hover:tw-shadow-xl hover:-tw-translate-y-0.5 active:tw-translate-y-0"
            onClick={nextButtonClickHandler}
            disabled={selectAuthenticator.length === 0}
          >
            NEXT
          </Button>
        </div>
      </div>
    </div>
  );
};
export default Authenticator;
